import { render, staticRenderFns } from "./ProctoredAttestationTest.vue?vue&type=template&id=e8b55d58&"
import script from "./ProctoredAttestationTest.vue?vue&type=script&lang=js&"
export * from "./ProctoredAttestationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports